<template>
  <gj-card
      :title="data.title+((data.currencySymbol&&needSymbol)?`(${data.currencySymbol})`:'')"
      :number="needSymbol?amountSymbol(data.today):defaultShow(data.today,'',data.title==='销售毛利率'?'%':'')"
      padding="10px 14px 6px 12px"
      :hasTip="['销售额','销量','订单量'].includes(data.title)"
  >
    <template #hasTip>
      已支付{{data.title}}：{{data.payToday | defaultShow(needSymbol?data.currencySymbol:'')}}<br>
      将支付{{data.title}}：{{data.noPayToday | defaultShow(needSymbol?data.currencySymbol:'')}}<br>
      总{{data.title}}：{{data.today | defaultShow(needSymbol?data.currencySymbol:'')}}
    </template>

    <template #compare>
      <div class="size12 flex" style="margin-left: 16px" v-if="isMeaningful(compare)">
        <div class="color999">较昨日</div>
        <div :class="{'colorRed':compare<0,'colorGreen':compare>=0}" style="margin-left: 4px;">
          <template v-if="compare>=0">+</template>
          <span v-if="needSymbol">{{amountSymbol(compare).value}}{{amountSymbol(compare).unit}}</span>
          <span v-else>{{compare | defaultShow('',data.title==='销售毛利率'?'%':'')}}</span>
        </div>
      </div>
    </template>

    <template #title v-if="!['退款量','销售毛利率'].includes(data.title)">
      <gj-help>
        数据来源：亚马逊销售订单<br>
        计算规则：{{data.help}}<br>
        使用说明：由于包含未付款订单，所以整体{{data.title}}会出现一定数据的浮动
      </gj-help>
    </template>

    <template #info>
      <div class="flex justify-between">
        <div class="flex justify-between" style="flex: 1">
          <div>昨日</div>
          <div v-if="needSymbol" style="color: #333;">{{ amountSymbol(data.yesterday).value}}{{ amountSymbol(data.yesterday).unit}}</div>
          <div v-else style="color: #333;">{{ data.yesterday | defaultShow('',data.title==='销售毛利率'?'%':'') }}</div>
        </div>
        <div class="flex justify-between card-info2">
          <div>上月同日</div>
          <div v-if="needSymbol" style="color: #333;">{{ amountSymbol(data.lastMonth).value}}{{ amountSymbol(data.lastMonth).unit}}</div>
          <div v-else class="flex align-center" style="color: #333;">{{ data.lastMonth | defaultShow('',data.title==='销售毛利率'?'%':'') }}
            <!--                <i class="iconfont"-->
            <!--                    :class="{'icon-xiajiang': data.yesterdaySalesCompare < 0,'down-icon': data.yesterdaySalesCompare < 0,'icon-shangsheng': data.yesterdaySalesCompare > 0,'up-icon': data.yesterdaySalesCompare > 0}"></i>-->
          </div>
        </div>
      </div>
      <div class="flex justify-between" style="margin-top: 4px;">
        <div class="flex justify-between" style="flex: 1">
          <div>上周同日</div>
          <div v-if="needSymbol" style="color: #333;">{{ amountSymbol(data.lastWeek).value}}{{ amountSymbol(data.lastWeek).unit}}</div>
          <div v-else style="color: #333;">{{ data.lastWeek | defaultShow('',data.title==='销售毛利率'?'%':'') }}</div>
        </div>
        <div class="flex justify-between card-info2">
          <div>去年同日</div>
          <div v-if="needSymbol" style="color: #333;">{{ amountSymbol(data.lastYear).value}}{{ amountSymbol(data.lastYear).unit}}</div>
          <div v-else class="flex align-center" style="color: #333;">{{ data.lastYear | defaultShow('',data.title==='销售毛利率'?'%':'') }}
            <!--                <i class="iconfont"-->
            <!--                    :class="{'icon-xiajiang': data.lastWeekSalesCompare < 0,'down-icon': data.lastWeekSalesCompare > 0,'icon-shangsheng': data.lastWeekSalesCompare > 0,'up-icon': data.lastWeekSalesCompare > 0}"></i>-->
          </div>
        </div>
      </div>
    </template>
  </gj-card>
</template>

<script>
import {toFixed, isMeaningful} from "@/utils/common";
import {defaultShow, amountSymbol} from "@/filters";
export default {
  name: "dashboard-sale-instant-card",
  props:{
    data:{
      type: Object,
      default:()=>{}
    }
  },
  computed:{
    //对比值
    compare(){
      return toFixed(this.data.today-this.data.yesterday)
    },
    // 是否需要对数值处理 （’万‘、’亿‘、‘，’）
    needSymbol(){
      return ['销售额','平均单价'].includes(this.data.title)
    }
  },
  methods:{
    defaultShow,
    amountSymbol,
    toFixed,
    isMeaningful
  }
}
</script>

<style scoped lang="scss">
.gj-card {
  flex: 1;
  border-radius: 2px;
  margin: 0;
}

.gj-card + .gj-card {
  margin-left: 16px;
}

.card-info2 {
  flex: 1;
  margin-left: 36px;
//padding-right: 7px;
}
.iconfont{
  font-size: 16px;
}
.gj-card-border{
  border: 1px solid #E4E5E6;
}
/deep/.gj-help--icon{
  color: #999;
}
</style>